export enum ContentTypeIcon {
    PDF = "PDF",
    EXCEL = "ExcelDocument",
    WORD = "WordDocument",
    JPEG = "FileImage",
    JPG = "FileImage",
    PNG = "FileImage",
}
